import Form from 'mobx-react-form';
import { muiFormBindings } from 'forms/utils/muiFormBindings';
import { plugins } from 'forms/utils/formPlugins';
import { FieldsDefinitions } from 'mobx-react-form/lib/models/FormInterface';
import { userProfile, userSettings } from 'utils/labels';
import { formOptions } from 'forms/utils/formOptions';
import { isEmail, isRequired } from 'forms/utils/validators';

const fields: FieldsDefinitions = [
  {
    name: 'fullName',
    label: userProfile.fullName,
    bindings: 'TextField',
    value: '',
    validators: [isRequired],
  },
  {
    name: 'email',
    label: userProfile.email,
    bindings: 'TextField',
    value: '',
    validators: [isEmail],
  },
  {
    name: 'jobRole',
    label: userProfile.jobRole,
    bindings: 'AutoCompleteTextField',
    value: '',
    validators: [isRequired],
  },
  {
    name: 'companyName',
    label: userProfile.companyName,
    bindings: 'AutoCompleteTextField',
    // eslint-disable-next-line no-restricted-syntax
    value: null,
    validators: [isRequired],
  },
  {
    name: 'hasCostarLicense',
    label: userSettings.hasCostarLicense,
    bindings: 'Checkbox',
    value: false,
  },
];

export function createForm() {
  return new Form({ fields }, { plugins, bindings: muiFormBindings, options: formOptions });
}
